
/***
 * Funcion que devuelve un objeto con todos los valores de analitica provenientes de datalayer (Google)
 * Es normal que falle en Pre debido a que no esta el datalayer de google comos sus funciones
 * @return {Object} valores analitica
 * 
*/
export const getAnalitycStorage=()=>{

    const objAnalitycs = {
        ad_storage:globalThis.google_tag_data.ics.getConsentState("ad_storage")==1?"granted":"denied",
        ad_personalization:globalThis.google_tag_data.ics.getConsentState("ad_personalization")==1?"granted":"denied",
        ad_user_data:globalThis.google_tag_data.ics.getConsentState("ad_user_data")==1?"granted":"denied",
        analytics_storage:globalThis.google_tag_data.ics.getConsentState("analytics_storage")==1?"granted":"denied",
        functionality_storage:globalThis.google_tag_data.ics.getConsentState("functionality_storage")==1?"granted":"denied",
        personalization_storage:globalThis.google_tag_data.ics.getConsentState("personalization_storage")==1?"granted":"denied",
        security_storage:globalThis.google_tag_data.ics.getConsentState("security_storage")==1?"granted":"denied",
    };
    

    const handler = {
    
        get(target, prop) {
            //Comprobamos existencia en datalyer
            if (prop in target) {
                return target[prop];
            } else {
                console.eroor (`La propiedad "${prop}" no existe en el datalayer de GA.`);
                return undefined; 
            }
        },
    
        set(target, prop, value) {
            if (typeof globalThis.google_tag_data.ics.getConsentState(target)!=null && typeof globalThis.google_tag_data.ics.getConsentState(target)!="undefined") {
                // Asignamos valor 
                target[prop] = value;
                 return true; 
                
            }else{
                console.error(`La propiedad ${prop} no esta contemplada en el datalayer de GA` );
                return false; 
            }

           
        }
    };
    
    // Creación del Proxy
    const objetoAnalitycs = new Proxy(objAnalitycs, handler);

    return objetoAnalitycs

}